import React from 'react';

// Material UI
import CenterFocusStrongIcon from '@mui/icons-material/CenterFocusStrong';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

/**
 * Reset Zoom Button Component
 * A reusable button for resetting chart zoom and pan states
 * 
 * @param {function} onClick - Handler function called when button is clicked (required)
 * @param {string} tooltipText - Text to display in tooltip (optional)
 * @param {string} size - Size of the button: 'small', 'medium', or 'large' (optional)
 * @param {string} ariaLabel - Accessibility label for the button (optional)
 * @param {React.Component} icon - Custom icon component to display (optional)
 * @param {object} sx - Additional Material-UI sx styling props (optional)
 */
export default function ResetZoomButton({
	onClick,
	tooltipText = "Reset zoom and pan to default view",
	size = "small",
	ariaLabel = "reset graph zoom",
	icon: CustomIcon = CenterFocusStrongIcon,
	sx = {},
}) {
	// Default styling merged with custom sx props
	const defaultSx = {
		margin: 0.5,
		width: '28px',
		height: '28px',
		borderRadius: '6px',
		backgroundColor: 'white',
		border: '1px solid lightgray',
		color: 'black',
		":hover": {
			backgroundColor: 'lightgray',
			boxShadow: 'none',
		},
		...sx,
	};

	return (
		<Tooltip title={tooltipText} arrow>
			<IconButton
				onClick={onClick}
				aria-label={ariaLabel}
				size={size}
				sx={defaultSx}
			>
				<CustomIcon />
			</IconButton>
		</Tooltip>
	);
}
